import { CaretDownIcon } from '@phosphor-icons/react';

import { ActionMenu } from '@/components/common/action-menu';

import { STATUS_TRANSITIONS, isFinalStatus } from '../constants';
import { ORDER_STATUS_CHIP } from '../format';
import { useOrderStatusActions } from '../order-actions';
import type { OrderDetail } from '../types';

import styles from './order-detail.module.scss';

/** Status pill that opens the allowed transitions; final statuses render the same pill, disabled. */
export function OrderStatusControl({ order }: { order: OrderDetail }) {
  const { changeStatus } = useOrderStatusActions(order);
  const chip = ORDER_STATUS_CHIP[order.status];

  if (isFinalStatus(order.status)) {
    return (
      <button type="button" className={styles.statusTrigger} disabled>
        <span>{chip.label}</span>
        <CaretDownIcon size={16} />
      </button>
    );
  }

  return (
    <ActionMenu
      triggerLabel="Change order status"
      groups={[
        {
          items: STATUS_TRANSITIONS[order.status].map((s) => ({
            key: s,
            label: ORDER_STATUS_CHIP[s].label,
            danger: s === 'cancelled',
            onClick: () => void changeStatus(s),
          })),
        },
      ]}
    >
      <button type="button" className={styles.statusTrigger}>
        <span>{chip.label}</span>
        <CaretDownIcon size={16} />
      </button>
    </ActionMenu>
  );
}
